import { render, staticRenderFns } from "./intelligent.vue?vue&type=template&id=06cf9b7c&scoped=true"
import script from "./intelligent.vue?vue&type=script&lang=js"
export * from "./intelligent.vue?vue&type=script&lang=js"
import style0 from "./intelligent.vue?vue&type=style&index=0&id=06cf9b7c&prod&lang=less&scoped=true"
import style1 from "./intelligent.vue?vue&type=style&index=1&id=06cf9b7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06cf9b7c",
  null
  
)

export default component.exports